var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":"","app":""}},[_c('span',[_vm._v(_vm._s(_vm.$t("footer.copyright")))])])}
var staticRenderFns = []

export { render, staticRenderFns }